import { XdrSearchQueryPanelWebComponent } from './component/XdrSearchQueryPanelWebComponent';
import { WEB_COMPONENT_XDR_SEARCH_QUERY_PANEL } from '../../webcomponents.constants';

export { XdrSearchQueryPanelWebComponent };

window.customElements.define(WEB_COMPONENT_XDR_SEARCH_QUERY_PANEL, XdrSearchQueryPanelWebComponent);
